import { useMemo, useState } from "react";
import "@/App.css";
import { ThemeProvider } from "next-themes";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { Toaster } from "@/components/ui/sonner";
import AdminPage from "@/pages/AdminPage";
import ApplyPage from "@/pages/ApplyPage";
import ComplaintPage from "@/pages/ComplaintPage";
import ContributionPage from "@/pages/ContributionPage";
import FaqPage from "@/pages/FaqPage";
import GlossaryPage from "@/pages/GlossaryPage";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import LoginPage from "@/pages/LoginPage";
import MemberPage from "@/pages/MemberPage";
import ProcedurePage from "@/pages/ProcedurePage";

function App() {
  const [session, setSession] = useState(() => {
    try {
      const stored = window.localStorage.getItem("reexperts-session");
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  });

  const sessionValue = useMemo(() => session, [session]);

  const handleLogin = (nextSession) => {
    setSession(nextSession);
    window.localStorage.setItem("reexperts-session", JSON.stringify(nextSession));
  };

  const handleLogout = () => {
    setSession(null);
    window.localStorage.removeItem("reexperts-session");
  };

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/apply" element={<ApplyPage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/begriffsverzeichnis" element={<GlossaryPage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/faq" element={<FaqPage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/rechtliches" element={<LegalPage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/verfahrensordnung" element={<ProcedurePage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/beitragsordnung" element={<ContributionPage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/beschwerde" element={<ComplaintPage session={sessionValue} onLogout={handleLogout} />} />
            <Route path="/login" element={<LoginPage session={sessionValue} onLogout={handleLogout} onLogin={handleLogin} />} />
            <Route path="/mitglied" element={sessionValue?.user ? <MemberPage session={sessionValue} onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
            <Route path="/admin" element={sessionValue?.user?.role === "admin" ? <AdminPage session={sessionValue} onLogout={handleLogout} /> : <Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
